import Vue from 'vue'
import Vuex from 'vuex'
import {getUserInfo,getCartNum} from "@/api/user"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	   user: null ,// 初始用户信息
	   cartNum:0
  },
  getters: {
  },
  mutations: {
		setUser(state, user) {
			state.user = user;
		},
		setCartNum(state, cartNum) {
			state.cartNum = cartNum;
		}
  },
  actions: {
	fetchUser({ commit }) {
		// 模拟异步获取用户信息
		getUserInfo().then(res=>{
			if(res.code == 1000){
				commit('setUser', res.data);
			}else{
				commit('setUser', null);
			}
		})
	},
	fetchCartNum({ commit }) {
		// 模拟异步获取用户信息
		getCartNum().then(res=>{
			if(res.code == 1000){
				commit('setCartNum', res.data);
			}else{
				commit('setCartNum', 0);
			}
		})
	}
  },
  modules: {
  }
})
